export default __webpack_public_path__ + "static/media/Thumbnail-Newsletter-10.17cb57e1.png";